import { useCallback, useState } from 'react'

// Derive the first page synchronously when filters change: never request an old
// page with a new search/filter combination.
export function useListPagination(filters) {
  const signature = JSON.stringify(filters)
  const [state, setState] = useState({ signature, page: 1 })
  const page = state.signature === signature ? state.page : 1
  const setPage = useCallback((nextPage) => {
    setState({ signature, page: Math.max(1, nextPage) })
  }, [signature])
  // Remember the new signature even if the user changes filters back before
  // navigating. This is a guarded adjustment of this component's own state.
  if (state.signature !== signature) setState({ signature, page: 1 })
  return { page, setPage }
}
